export const GET_CLIENT_CAMPAIGN_FULFILLMENT = "GET_CLIENT_CAMPAIGN_FULFILLMENT"
export const GET_CLIENT_CAMPAIGN_FULFILLMENT_SUCCESS = "GET_CLIENT_CAMPAIGN_FULFILLMENT_SUCCESS"
export const GET_CLIENT_CAMPAIGN_FULFILLMENT_ERROR = "GET_CLIENT_CAMPAIGN_FULFILLMENT_ERROR"

export const EXPORT_CLIENT_CAMPAIGN_FULFILLMENT = "EXPORT_CLIENT_CAMPAIGN_FULFILLMENT"
export const EXPORT_CLIENT_CAMPAIGN_FULFILLMENT_SUCCESS = "EXPORT_CLIENT_CAMPAIGN_FULFILLMENT_SUCCESS"
export const EXPORT_CLIENT_CAMPAIGN_FULFILLMENT_ERROR = "EXPORT_CLIENT_CAMPAIGN_FULFILLMENT_ERROR"